// DS2 Message Box: a message in the colour of its type, with its icon. the children may hold markup (a link, bold text).
// role alert for warning and error, status otherwise.
import cx from "classnames";
import type { PropsWithChildren, Ref } from "react";
import { MESSAGE_ICON, type MessageBoxType } from "./messageIcons";
import styles from "./MessageBox.module.css";

export type { MessageBoxType } from "./messageIcons";

export type MessageBoxProps = PropsWithChildren<{
  type?: MessageBoxType;
  className?: string;
  ref?: Ref<HTMLDivElement>;
}>;

export function MessageBox({ children, type = "informative", className, ref }: MessageBoxProps) {
  const Icon = MESSAGE_ICON[type];
  return (
    <div
      ref={ref}
      className={cx(styles.box, styles[type], className)}
      role={type === "error" || type === "warning" ? "alert" : "status"}
    >
      <Icon className={styles.icon} />
      <div className={styles.text}>{children}</div>
    </div>
  );
}
